// Module
var code = "<div class=\"progress-bar-component\"> <span>{{stepCurrent}} / {{stepTotal}}</span> <div v-for=\"index in stepCurrent\" :key=\"index\" class=\"step\"></div> <div v-for=\"index in numberStepDisable\" :key=\"index\" class=\"step disable\"></div> </div>";
// Exports
export default code;